// extracted by mini-css-extract-plugin
module.exports = {"info-box":"info-box_info-box__1n6ES"};